import { SectionsAnalyticsPage } from "../SectionsAnalyticsPage/index";

const SectionsAnalyticsTimePage = () => (
  <SectionsAnalyticsPage analyticsType="directMessage" />
);

export default SectionsAnalyticsTimePage;
